﻿import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const id: Dictionary = {
  "nav": {
    "home": "Beranda",
    "map": "Peta",
    "tracker": "Pelacak",
    "resources": "Sumber Daya",
    "fish": "Ikan",
    "insects": "Serangga",
    "birds": "Burung",
    "foraging": "Hasil Alam",
    "crops": "Tanaman",
    "flowers": "Bunga",
    "animals": "Hewan",
    "recipes": "Resep",
    "locations": "Lokasi",
    "npcs": "NPC",
    "shops": "Toko",
    "guides": "Panduan",
    "news": "Berita",
    "achievements": "Pencapaian",
    "weather": "Cuaca",
    "events": "Event",
    "pets": "Hewan Peliharaan",
    "dailyChecklist": "Checklist Harian",
    "codes": "Kode Redeem",
    "winterTracker": "Pelacak Musim Dingin",
    "support": "Dukungan",
    "about": "Tentang",
    "furniture": "Furnitur",
    "wardrobe": "Pakaian",
    "buildings": "Bangunan",
    "resourcesCollection": "Koleksi",
    "resourcesDecorate": "Dekorasi",
    "resourcesExplore": "Jelajahi",
    "resourcesLearn": "Pelajari",
    "menu": "Menu",
  },
  "search": {
    "placeholder": "Cari semuanya…",
    "categoryItems": "Koleksi",
    "categoryNpcs": "NPC",
    "categoryLocations": "Lokasi",
    "categoryGuides": "Panduan",
    "categoryNews": "Berita",
    "categoryAchievements": "Pencapaian",
    "noResults": "Tidak ada hasil yang ditemukan",
    "noResultsHint": "Coba istilah pencarian lain",
    "navigate": "navigasi",
    "select": "pilih",
    "close": "tutup",
  },
  "language": {
    "title": "Bahasa",
    "subtitle": "Pilih bahasa pilihanmu",
  },
  "footer": {
    "description": "Panduan Heartopia buatan pemain untuk rute, resep, lokasi, dan koleksi.",
    "quickLinks": "Tautan Cepat",
    "collection": "Koleksi",
    "copyright": "Heartopia Hub",
    "disclaimer": "Tidak berafiliasi dengan pengembang Heartopia.",
  },
  "home": {
    "badge": "Pendamping Heartopia tidak resmi",
    "titleStop": "Berhenti",
    "titleWandering": "tersesat.",
    "titleStart": "Mulai merencanakan.",
    "description":
      "Heartopia.guide menyatukan peta pulau, resep, makhluk, NPC, dan progres koleksi dalam satu tempat yang ringkas dan cepat.",
    "openAtlas": "Buka atlas",
    "tracker": "Pelacak",
    "statCatalogued": "Item yang dikatalogkan",
    "statLayers": "Lapisan peta",
    "statFree": "Selalu gratis",
    "islandAtlas": "Atlas pulau",
    "mapLayerNpcs": "NPC",
    "mapLayerShops": "Toko",
    "mapLayerAnimals": "Hewan",
    "mapHeading": "Pulau Heartopia",
    "mapNearby": "di dekat sini",
    "openMap": "Buka peta",
    "meetLocals": "Temui penduduk setempat",
    "hintNpcs": "Lihat semua NPC yang bisa diajak bicara dalam sekali pandang.",
    "hintShops": "Lihat setiap toko beserta barang yang dijualnya.",
    "hintAnimals": "Temukan hewan liar di lokasi biasanya.",
    "explore": "Jelajahi",
    "recipesPill": "Resep",
    "recipesTitle": "Masak lebih cerdas",
    "recipesDescription": "Jelajahi hidangan, rantai bahan, dan kemajuan pengumpulan tanpa membuka sepuluh tab.",
    "viewRecipes": "Lihat resep",
    "ingr": "bahan",
    "profit": "laba",
    "animalsPill": "Hewan liar",
    "animalsTitle": "Temui mereka semua",
    "animalsDescription": "Makanan favorit, kondisi cuaca, dan petunjuk lokasi untuk setiap hewan liar.",
    "viewAnimals": "Lihat hewan",
    "guidesPill": "Panduan",
    "guidesTitle": "Pilih fokus",
    "guidesDescription":
      "Pilih salah satu dari tiga jalur — langsung buka panduan yang sesuai dengan tujuanmu saat ini.",
    "allGuides": "Semua panduan",
    "exploreGuide": "Jelajahi panduan",
  },
  "guides": {
    "pillLabel": "Panduan Lapangan",
    "titleLearn": "Pelajari",
    "titleAccent": "Setiap Sistem",
    "searchPlaceholder": "Cari panduan…",
    "categoryAll": "Semua",
    "categoryBeginner": "Pemula",
    "categoryCrafting": "Crafting",
    "categoryCooking": "Cooking",
    "categoryFishing": "Fishing",
    "categoryExploration": "Eksplorasi",
    "difficultyEasy": "Mudah",
    "difficultyMedium": "Sedang",
    "difficultyHard": "Sulit",
    "allGuides": "Semua panduan",
    "by": "Oleh",
    "minRead": "min baca",
    "noResults": "Tidak ada panduan yang ditemukan. Coba penelusuran atau kategori lain.",
    "relatedGuides": "Panduan terkait",
    "readGuide": "Baca panduan",
  },
  "news": {
    "pillLabel": "Berita Heartopia",
    "titleWhats": "Apa",
    "titleAccent": "Baru",
    "searchPlaceholder": "Cari berita…",
    "categoryAll": "Semua",
    "categoryEvent": "Event",
    "categoryUpdate": "Pembaruan",
    "categoryGuide": "Panduan",
    "categoryNews": "Berita",
    "featured": "Unggulan",
    "allNews": "Semua berita",
    "read": "Baca",
  },
  "map": {
    "controls": "Kontrol peta",
    "zoomIn": "Perbesar",
    "zoomOut": "Perkecil",
    "resetMap": "Setel ulang peta",
    "fullscreen": "Layar penuh",
    "viewDetails": "Lihat detail",
    "viewLocation": "Lihat lokasi",
    "openFullMap": "Buka peta penuh",
    "seeMore": "Lihat selengkapnya",
    "close": "Tutup",
    "back": "Kembali",
    "guide": "Panduan",
    "searchPlaceholder": "Cari NPC, toko, burung, ikan...",
    "clearSearch": "Hapus pencarian",
    "area": "Area",
    "mapArea": "Area peta",
    "event": "Event",
    "resource": "Sumber",
    "location": "Lokasi",
    "npc": "NPC",
    "shop": "Toko",
    "busStop": "Halte Bus",
    "wildAnimal": "Hewan Liar",
    "focus": "Fokus",
    "hide": "Sembunyikan",
    "show": "Tampilkan",
    "showAllShops": "Tampilkan semua toko",
    "showAllAnimals": "Tampilkan semua hewan",
    "showBugAreas": "Tampilkan area serangga",
    "showBirdAreas": "Tampilkan area burung",
    "showResources": "Tampilkan sumber daya di peta",
    "showEvents": "Tampilkan event di peta",
    "showFishAreas": "Tampilkan area ikan",
    "viewAnimalAreas": "Lihat area hewan",
    "clickToView": "Klik untuk melihat",
    "spots": "lokasi",
    "meteorShower": "Hujan meteor",
    "foundIn": "Ditemukan di",
    "more": "lainnya",
    "sectionsNpcs": "NPC",
    "sectionsShops": "Toko",
    "sectionsBusStops": "Halte Bus",
    "sectionsAnimals": "Hewan",
    "sectionsBugs": "Serangga",
    "sectionsBirds": "Burung",
    "sectionsResources": "Sumber Daya",
    "sectionsWeather": "Cuaca",
    "sectionsEvents": "Event",
    "sectionsFish": "Ikan",
    "shopClothes": "Pakaian",
    "shopFurniture": "Mebel",
    "shopPets": "Hewan Peliharaan",
    "shopBookstore": "Toko buku",
    "helpTitle": "Cara menggunakan peta",
    "helpSearchLead": "Cari",
    "helpSearchText": "NPC, toko, makhluk, atau area berdasarkan nama melalui kolom di bagian atas.",
    "helpLayersLead": "Lapisan",
    "helpLayersText":
      "di sidebar aktifkan apa yang terlihat di peta: NPC, Toko, Hewan, Sumber Daya, dan banyak lagi. Ketuk salah satu kategori untuk memperluas daftar lengkapnya.",
    "helpClickLead": "Klik pin, area, atau item daftar",
    "helpClickText":
      "untuk melihat info dasar pada kartu di bagian bawah peta, dengan tombol untuk melihat halaman detail lengkap jika ada.",
  },
  "locations": {
    "title": "Lokasi",
    "subtitleSuffix": "lokasi di seluruh Pulau Heartopia",
    "openMap": "Buka Peta",
    "searchPlaceholder": "Cari lokasi…",
    "allLocations": "Semua Lokasi",
    "npcsHere": "NPC Di Sini",
    "shopsHere": "Toko Di Sini",
    "listings": "daftar",
    "foundHereTitle": "Temukan di Sini",
    "foundHereHint": "Makhluk dan sumber daya yang bisa dikumpulkan di tempat ini.",
    "onTheMapTitle": "Di Peta",
    "sameRegionTitle": "Lainnya di wilayah {region}",
    "statNpcs": "NPC",
    "statShops": "Toko",
    "statCollectibles": "Koleksi",
    "levelShort": "Lv. {level}",
    "eventOnly": "Event",
    "seeListings": "Lihat barang",
    "seeAll": "Lihat semua",
    "timeOfDay": "Waktu",
    "nothingHereTitle": "Belum ada yang tercatat di sini",
    "nothingHereBody":
      "Belum ada catatan makhluk, toko, atau NPC untuk tempat ini. Kalau menemukan sesuatu di sini, peta adalah cara tercepat untuk memberi tahu kami.",
    "regionTown": "Kota",
    "regionNature": "Alam",
    "regionAdventure": "Petualangan",
    "regionCoast": "Pesisir",
    "regionSea": "Laut",
    "regionRegion": "Wilayah",
    "regionFishingVillage": "Fishing Village",
    "regionForest": "Hutan",
    "regionMountain": "Gunung",
    "regionBeach": "Pantai",
    "regionOther": "Lainnya",
  },
  "catalog": {
    "howItWorks": "Bagaimana cara kerjanya",
    "fishPill": "Ensiklopedia Fishing",
    "fishTitlePrefix": "Menangkap",
    "fishTitleAccent": "Setiap Ikan",
    "fishSearchPlaceholder": "Cari ikan, habitat, ukuran bayangan…",
    "fishSliderLabel": "Tingkat Fishing",
    "fishIntroTitle": "Fishing 101",
    "fishIntroP1":
      "Lempar kail di dekat habitat ikan untuk menangkapnya — ukuran bayangan memberi petunjuk ikan yang menyambar.",
    "fishIntroP2":
      "Tingkat penangkapan ikan yang lebih tinggi membuka tangkapan yang lebih langka, dan kualitas bintang melipatgandakan harga jual Anda.",
    "fishUnknownHabitat": "Perairan yang tidak diketahui",
    "fishHabitat": "Habitat",
    "fishNoResultsTitle": "Tidak ada ikan yang ditemukan",
    "fishNoResultsBody": "Coba sesuaikan filter Anda.",
    "fishPastEventTitle": "Ikan dari Event Sebelumnya",
    "fishHeaderTitle": "Ikan",
    "fishColFish": "Ikan",
    "fishColShadow": "Bayangan",
    "insectsPill": "Ensiklopedia Bug Catching",
    "insectsTitlePrefix": "Menangkap",
    "insectsTitleAccent": "Setiap Serangga",
    "insectsSearchPlaceholder": "Cari serangga, habitat…",
    "insectsSliderLabel": "Tingkat Penangkapan",
    "insectsIntroTitle": "Bug Catching 101",
    "insectsIntroP1": "Gunakan jaring serangga Anda di dekat habitat serangga untuk menangkapnya.",
    "insectsIntroP2":
      "Level menangkap yang lebih tinggi membuka serangga yang lebih langka, dan kualitas bintang melipatgandakan harga jualnya.",
    "insectsUnknownHabitat": "Tidak dikenal",
    "insectsPastEventTitle": "Serangga dari Event Sebelumnya",
    "insectsHeaderTitle": "Serangga",
    "insectsColInsect": "Serangga",
    "birdsPill": "Ensiklopedia Birdwatching",
    "birdsTitlePrefix": "Temukan",
    "birdsTitleAccent": "Setiap Burung",
    "birdsSearchPlaceholder": "Cari burung, habitat…",
    "birdsSliderLabel": "Tingkat Birdwatching",
    "birdsIntroTitle": "Birdwatching 101",
    "birdsIntroP1": "Tunggu di dekat habitat burung dengan semak kamuflase Anda untuk mengambil foto.",
    "birdsIntroP2": "Tingkat pengamatan burung yang lebih tinggi akan membuka spesies yang lebih langka.",
    "birdsUnknownHabitat": "Tidak dikenal",
    "birdsPastEventTitle": "Burung dari Event Sebelumnya",
    "birdsHeaderTitle": "Burung",
    "birdsColBird": "Burung",
    "cropsPill": "Ensiklopedia Pertanian",
    "cropsTitlePrefix": "Tanam",
    "cropsTitleAccent": "Setiap Tanaman",
    "cropsSearchPlaceholder": "Cari tanaman…",
    "cropsIntroTitle": "Pertanian 101",
    "cropsIntroP1": "Tanam benih di lahan pertanian Anda dan sirami setiap hari sampai panen.",
    "cropsIntroP2": "Beberapa tanaman hanya tumbuh pada musim tertentu — periksa lencana musim sebelum tanam.",
    "cropsAllSeasons": "Semua Musim",
    "cropsGrowthTime": "Waktu Tumbuh",
    "cropsGrowthTimeUnknown": "Tidak dikenal",
    "cropsGrowthTimeMinutesSuffix": "menit",
    "cropsSortGrowthTime": "Waktu Tumbuh",
    "cropsHeaderTitle": "Tanaman",
    "cropsColCrop": "Tanaman",
    "cropsColSeason": "Musim",
    "flowersPill": "Ensiklopedia Gardening",
    "flowersTitlePrefix": "Tanam",
    "flowersTitleAccent": "Setiap Bunga",
    "flowersSearchPlaceholder": "Cari bunga…",
    "flowersIntroTitle": "Gardening 101",
    "flowersIntroP1": "Tanam benih bunga dan sirami hingga mekar.",
    "flowersHeaderTitle": "Bunga",
    "flowersColFlower": "Bunga",
    "furniturePill": "Katalog Furnitur",
    "furnitureTitlePrefix": "Semua",
    "furnitureTitleAccent": "Furnitur di Game",
    "furnitureSearchPlaceholder": "Cari furnitur…",
    "furnitureMetaDescription":
      "Semua furnitur di Heartopia — penerangan, kursi, meja, tempat tidur, karpet dan dekorasi — bisa disaring per jenis, ruangan dan warna, lengkap dengan semua varian desain dan harga dalam gold dan Wishing Star.",
    "browseAll": "Semua",
    "browseVariants": "{count} desain",
    "browseShowMore": "Tampilkan {count} lagi",
    "browseFacetRooms": "Ruangan",
    "browseFacetColors": "Warna",
    "browseFacetSlots": "Bagian",
    "browseFacetTypes": "Jenis",
    "browseFacetSets": "Koleksi",
    "browseCollectionsMore": "Lihat semua",
    "browseCollectionsLess": "Tampilkan lebih sedikit",
    "browseCollectionPieces": "{count} item",
    "browseFavourites": "Favorit",
    "browseNoArt": "Game tidak menyediakan gambar untuk yang ini",
    "browseFacetStyles": "Gaya bangunan",
    "buildingsPill": "Katalog Mode Bangun",
    "buildingsTitlePrefix": "Semua",
    "buildingsTitleAccent": "Bagian Bangunan",
    "buildingsSearchPlaceholder": "Cari pintu, atap, jendela…",
    "buildingsMetaDescription":
      "Semua bagian mode bangun di Heartopia — pintu, jendela, atap, pagar, ukiran dinding dan tekstur dinding maupun lantai — dikelompokkan per gaya bangunan, lengkap dengan harga dan semua varian desain.",
    "wardrobePill": "Katalog Pakaian",
    "wardrobeTitlePrefix": "Semua",
    "wardrobeTitleAccent": "Busana & Aksesori",
    "wardrobeSearchPlaceholder": "Cari pakaian…",
    "wardrobeMetaDescription":
      "Semua topi, atasan, bawahan, sepatu, tas dan aksesori di Heartopia, bisa disaring per bagian dan warna, dengan harga dalam gold dan Wishing Star.",
    "forageablesPill": "Ensiklopedia Hasil Alam",
    "forageablesTitlePrefix": "Temukan",
    "forageablesTitleAccent": "Semua Hasil Alam",
    "forageablesSearchPlaceholder": "Cari hasil alam…",
    "forageablesIntroTitle": "Foraging 101",
    "forageablesIntroP1": "Berjalanlah di sekitar pulau dan petik tanaman dan jamur liar saat Anda menemukannya.",
    "forageablesEnergy": "Energi",
    "forageablesSortEnergy": "Energi",
    "forageablesHeaderTitle": "Hasil Alam",
    "forageablesColItem": "Barang",
    "recipesPill": "Daftar Lengkap Resep",
    "recipesTitlePrefix": "Masak",
    "recipesTitleAccent": "Setiap Hidangan",
    "recipesSearchPlaceholder": "Cari resep…",
    "recipesIntroTitle": "Cooking 101",
    "recipesIntroP1": "Kumpulkan bahan-bahan dan gunakan kompor, oven, atau pemanggang untuk memasak.",
    "recipesIntroP2":
      "Tingkat memasak yang lebih tinggi membuka resep yang lebih mewah dengan margin keuntungan yang lebih besar.",
    "recipesSortCookingLevel": "Tingkat Cooking",
    "recipesSortProfit": "Laba",
    "recipesEstProfit": "Estimasi Laba",
    "recipesViewRecipe": "Lihat resep",
    "recipesHeaderTitle": "Resep",
    "recipesColDish": "Hidangan",
    "recipesBeginnerFriendly": "Ramah Pemula",
    "recipesBestStartersTitle": "Resep Terbaik untuk Memulai",
    "recipesBestStartersSubtitle":
      "Tingkat memasak rendah, keuntungan besar — pilihan bagus untuk pembukaan Hobi Cooking pertama Anda.",
    "npcsPill": "Direktori Warga Kota",
    "npcsTitlePrefix": "Bertemu",
    "npcsTitleAccent": "Setiap NPC",
    "npcsSearchPlaceholder": "Telusuri NPC…",
    "npcsFilterAll": "Semua",
    "npcsFilterMentors": "Mentor",
    "npcsFilterShopkeepers": "Penjaga toko",
    "npcsFilterSpecial": "Spesial",
    "npcsNoResultsTitle": "Tidak Ditemukan NPC",
    "npcsNoResultsBody": "Coba sesuaikan pencarian Anda",
    "npcsResetFilters": "Setel Ulang Filter",
    "locationsPill": "Atlas Pulau",
    "locationsTitlePrefix": "Jelajahi",
    "locationsTitleAccent": "Setiap Lokasi",
    "locationsFilterAll": "Semua",
    "locationsNoResultsTitle": "Tidak Ada Lokasi yang Ditemukan",
    "locationsNoResultsBody": "Coba sesuaikan pencarian Anda",
    "locationsResetFilters": "Setel Ulang Filter",
    "shopsPill": "Direktori Toko",
    "shopsTitlePrefix": "Setiap",
    "shopsTitleAccent": "Toko di Kota",
    "shopsRunBy": "Dijalankan oleh:",
    "shopsAt": "Pada",
    "shopsItemsForSale": "barang untuk dijual",
    "shopsSearchPlaceholder": "Cari toko, NPC, lokasi…",
    "shopsNoResultsTitle": "Tidak Ada Toko yang Ditemukan",
    "shopsNoResultsBody": "Coba sesuaikan pencarian Anda",
    "shopsResetFilters": "Setel Ulang Filter",
    "animalsBadge": "Panduan Hewan Liar",
    "animalsTitlePrefix": "Bertemu",
    "animalsTitleAccent": "Setiap Hewan",
    "animalsPastEvent": "Event sebelumnya",
    "animalsPastEventTitle": "Hewan dari Event Sebelumnya",
    "trackerBadge": "Kemajuan pengumpulan",
    "trackerTitle": "Pelacak Heartopia",
    "trackerDescription":
      "Tandai ikan, serangga, burung, tanaman, bunga, hasil alam, resep, dan hewan liar yang sudah dikoleksi. Progres tersimpan di browser ini.",
    "trackerMetaDescription":
      "Lacak kemajuan pengumpulan Heartopia Anda pada ikan, serangga, burung, tanaman, bunga, makanan, hewan, dan resep.",
    "trackerCategoryTitle": "Pelacak {category}",
    "trackerCategoryMetaDescription":
      "Lacak kemajuan pengumpulan Heartopia {category} Anda — lihat apa yang telah Anda tangkap, tanam, atau masak, dan apa yang masih hilang.",
    "trackerTotal": "Total",
    "trackerExport": "Ekspor",
    "trackerImport": "Impor",
    "trackerReset": "Atur ulang",
    "trackerImportComplete": "Impor selesai.",
    "trackerImportFailed": "Impor gagal.",
    "trackerSearchPlaceholder": "Cari koleksi...",
    "trackerAllCategories": "Semua kategori",
    "trackerAllItems": "Semua item",
    "trackerCollected": "Dikumpulkan",
    "trackerMissing": "Hilang",
    "trackerNoResults": "Tidak ada item pelacak yang cocok dengan filter saat ini.",
  },
  "genericDetail": {
    "subtitle": "Entri ensiklopedia",
    "sellPrice": "Harga Jual",
    "energy": "Energi",
    "whereToBuy": "Tempat Membeli",
    "tags": "Tag",
    "crafted": "Dibuat",
    "aliases": "Juga dikenal sebagai",
    "howToObtain": "Cara mendapatkan",
    "growsInto": "Tumbuh Menjadi",
    "universalIngredientTitle": "Bahan masakan yang fleksibel",
    "universalIngredientBody": "Dapat digunakan sebagai pengganti bahan apa pun saat memasak resep.",
  },
  "animalDetail": {
    "backLabel": "Semua Hewan",
    "subtitle": "Entri Panduan Hewan Liar",
    "statLocation": "Lokasi",
    "statFavoriteWeather": "Cuaca Favorit",
    "foundInTitle": "Ditemukan di",
    "favoriteFoodsTitle": "Makanan Favorit",
    "noPinTitle": "Tempat pasti hewan ini belum dipasangi pin.",
    "noPinDescription": "Ia mengembara di dalam wilayahnya, jadi kami belum memetakan penanda pasti untuknya.",
    "weatherSunny": "Cerah",
    "weatherWet": "Hujan",
    "weatherRainbow": "Pelangi",
    "weatherSnowy": "Bersalju",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "cropDetail": {
    "backLabel": "Semua Tanaman",
    "subtitle": "Entri Ensiklopedia Pertanian",
    "statGrowthTime": "Waktu Tumbuh",
    "statSellPrice": "Harga Jual",
    "aboutTitle": "Tentang",
    "seedCostTitle": "Biaya Benih",
    "usedInRecipesTitle": "Digunakan dalam Resep",
    "sellPriceByStarTitle": "Harga Jual berdasarkan Bintang",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
    "shopsTitle": "Tempat Membeli Benih",
  },
  "creatureDetail": {
    "allBirds": "Semua Burung",
    "allInsects": "Semua Serangga",
    "allFish": "Semua Ikan",
    "birdSubtitle": "Entri Ensiklopedia Birdwatching",
    "insectSubtitle": "Entri Ensiklopedia Bug Catching",
    "fishSubtitle": "Entri Ensiklopedia Fishing",
    "statShadowSize": "Ukuran Bayangan",
    "markAsObtained": "Tandai sebagai diperoleh",
    "shopsTitle": "Tempat Membeli",
    "locationsTitle": "Habitat",
    "sellPriceByStarTitle": "Harga Jual berdasarkan Bintang",
    "starChanceHint": "Peluang mendapatkan tingkat bintang ini",
    "statWeightRange": "Berat",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "forageableDetail": {
    "backLabel": "Semua Makanan",
    "subtitle": "Entri Ensiklopedia Hasil Alam",
    "statEnergy": "Energi",
    "shopsTitle": "Tempat Membeli",
    "locationsTitle": "Ditemukan di",
    "aboutBody": "Berjalanlah mengelilingi pulau dan ambil ini saat Anda menemukannya di alam liar.",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "flowerDetail": {
    "backLabel": "Semua Bunga",
    "shopsTitle": "Tempat Membeli Benih",
    "encyclopediaEntry": "Entri Ensiklopedia Gardening",
    "colorsTitle": "Warna",
    "otherColorsTitle": "Warna Lainnya",
    "crossbreedingTitle": "Pembastaran",
    "crossbreedingFact1":
      "Hanya berlaku pada spesies yang sama — mawar hanya bisa disilangkan dengan mawar lain, bukan dengan tulip.",
    "crossbreedingFact2":
      "Bunga memiliki level bintang (1–5). Dua induk dengan bintang sama dapat menghasilkan level yang sama atau satu tingkat lebih tinggi; bintang bersebelahan (seperti 2★ dan 3★) bekerja dengan cara serupa. Bunga dengan selisih lebih besar tidak dapat disilangkan, dan bunga 5★ tidak menghasilkan benih lagi.",
    "crossbreedingFact3":
      "Warna bukan bahan campuran — warna kedua induk tidak menyatu menjadi warna ketiga. Setiap warna biasanya terkait dengan tingkat bintang tertentu pada spesiesnya, jadi hasil warna lebih ditentukan oleh tingkat bintang daripada warna awal.",
    "crossbreedingFact4":
      "Penyiraman meningkatkan peluang, hingga sekitar 5 orang (Anda dan maksimal 4 pembantu), sementara level Gardening memberi bonus tambahan. Hasil muncul setelah reset server pukul 06.00.",
    "crossbreedingDisclaimer":
      "Belum ada sumber tepercaya yang mendokumentasikan persentase keberhasilan secara pasti — naik tingkat mungkin terjadi, tetapi tidak pernah dijamin.",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "npcDetail": {
    "backLabel": "Semua NPC",
    "aboutTitle": "Tentang",
    "funFactsTitle": "Fakta Menarik",
    "foundInTitle": "Ditemukan di",
    "itemsForSale": "barang untuk dijual",
    "profileTitle": "Profil",
    "birthdayLabel": "Hari ulang tahun",
    "zodiacLabel": "Zodiak",
    "mbtiLabel": "MBTI",
    "likesTitle": "Suka",
    "roleLabel": "Peran",
    "teachesLabel": "Mengajar",
    "forSaleLabel": "Untuk dijual",
    "townsfolkFallback": "Penduduk kota",
    "townsfolkSubtitle": "Penduduk kota Heartopia",
    "itemsSuffix": "item",
    "noMapPinTitle": "Tempat persisnya NPC ini belum dipasangi pin.",
    "noMapPinDescription":
      "Mereka berkeliaran atau berpindah-pindah, jadi kami belum memetakan penanda tetap untuk mereka.",
    "currencyGold": "Gold",
    "currencyStars": "Stars",
    "currencyWishingStars": "Wishing Stars",
    "currencyMoonlightCrystals": "Moonlight Crystals",
    "currencyHeartDiamonds": "Heart Diamonds",
    "currencyExhibitionPasses": "Exhibition Passes",
    "currencyContributionMedals": "Contribution Medals",
    "seeAllShopItems": "Lihat semua {count} item di {shop} →",
  },
  "recipeDetail": {
    "faqIngredientsQuestion": "Bagaimana cara membuat {name}?",
    "faqIngredientsAnswer": "{name} membutuhkan: {ingredients}.",
    "faqLevelQuestion": "Level Cooking berapa yang dibutuhkan untuk {name}?",
    "faqLevelAnswer": "Perlu level Cooking {level} untuk membuka {name}.",
    "faqSellQuestion": "Berapa harga jual {name}?",
    "faqSellAnswer": "{name} terjual seharga {price} gold.",
    "faqStarQuestion": "Berapa nilai {name} bintang 5?",
    "faqStarAnswer":
      "{name} terjual seharga {min} gold di 1★ dan {max} gold di 5★ — {times}× lebih banyak untuk masakan sempurna.",
    "faqEnergyQuestion": "Berapa energi yang dipulihkan {name}?",
    "faqEnergyAnswer": "{name} memulihkan {min} energi di 1★ dan {max} energi di 5★.",
    "backLabel": "Semua Resep",
    "subtitle": "Entri Daftar Master Resep",
    "statCookingLevel": "Tingkat Cooking",
    "statTool": "Alat",
    "statSellPrice": "Harga Jual",
    "shopsTitle": "Tempat Membeli",
    "aboutTitle": "Tentang",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
    "ingredientsTitle": "Bahan-bahan",
    "noIngredients": "Tidak ada bahan yang dicatat untuk resep ini.",
    "missingIngredientsTitle": "Kami tidak tahu bahan untuk resep ini",
    "missingIngredientsCta": "Ketuk untuk menambahkannya",
    "suggestIngredientsModalTitle": "Sarankan bahan-bahannya",
    "ingredientSearchPlaceholder": "Cari item…",
    "ingredientQtyLabel": "Jumlah",
    "addIngredientRow": "Tambahkan bahan",
    "removeIngredientRow": "Hapus",
    "submitIngredients": "Kirim saran",
    "submittingIngredients": "Mengirim…",
    "ingredientsSuccessMessage": "Terima kasih! Kami akan segera meninjau saran Anda.",
    "ingredientsErrorMessage": "Tidak dapat mengirim saat ini — coba lagi nanti.",
    "itemNotFoundCta": "Tidak dapat menemukannya? Sarankan item baru",
    "newItemPendingBadge": "tertunda",
    "suggestNewItemModalTitle": "Sarankan item baru",
    "newItemNameLabel": "Nama item",
    "newItemNamePlaceholder": "mis. Mandarin",
    "newItemKindLabel": "Kategori",
    "newItemNotesLabel": "Catatan (opsional)",
    "newItemNotesPlaceholder": "Apa pun yang membantu kami menambahkannya — di mana ditemukan, seperti apa …",
    "submitNewItem": "Kirim saran",
    "submittingNewItem": "Mengirim…",
    "newItemSuccessMessage": "Terima kasih! Kami akan meninjau dan menambahkannya segera.",
    "newItemErrorMessage": "Tidak dapat mengirim saat ini — coba lagi nanti.",
    "anyTag": "setiap",
    "possibleSubstitutesTitle": "Kemungkinan pengganti",
    "possibleSubstitutesNote":
      "Semua item katalog dari jenis ini — daftar yang benar-benar diterima di Heartopia mungkin lebih terbatas.",
    "estIngredientCost": "Estimasi Biaya Bahan",
    "estProfit": "Estimasi Laba",
    "sellPriceByStar": "Harga Jual berdasarkan Bintang",
    "starScalingNote":
      "Skala memasak standar (1x/1,5x/2x/4x/8x) — sejumlah kecil hidangan diketahui menggunakan tabel yang berbeda.",
    "energyByStar": "Energi berdasarkan Bintang",
    "toolStove": "Kompor",
    "toolOven": "Oven",
    "toolPopcornServingCart": "Gerobak Popcorn",
    "toolPenguinStove": "Kompor Penguin",
    "toolBrickServingCart": "Gerobak Bata",
    "toolNone": "Tidak ada",
  },
  "common": {
    "loading": "Memuat",
    "overviewTitle": "Ringkasan",
    "viewDetails": "Lihat detail",
    "cards": "Kartu-kartu",
    "list": "Daftar",
    "sort": "Urutkan",
    "name": "Nama",
    "level": "Tingkat",
    "price": "Harga Jual",
    "clearFilters": "Hapus filter",
    "day": "hari",
    "days": "hari",
    "shadowSizeSmall": "Kecil",
    "shadowSizeMedium": "Sedang",
    "shadowSizeLarge": "Besar",
    "shadowSizeGolden": "Emas",
    "usedInRecipesTitle": "Digunakan dalam Resep",
    "aboutTitle": "Tentang",
  },
  "itemFaq": {
    "whereToFindQuestion": "Di mana saya bisa menemukan {name} di Heartopia?",
    "whereToFindByLocationsAnswer": "{name} bisa ditemukan di {locations}.",
    "whereToFindByHabitatAnswer": "{name} berkaitan dengan habitat {habitat}.",
    "levelRequiredQuestion": "Level berapa yang saya butuhkan untuk menangkap {name}?",
    "levelRequiredAnswer": "Anda butuh minimal level {level} untuk menangkap {name}.",
    "sellPriceQuestion": "Berapa harga jual {name}?",
    "sellPriceAnswer": "{name} dijual seharga {price} gold.",
    "sellPriceWithShadowAnswer":
      "{name} dijual seharga {price} gold, dan ukuran bayangannya saat memancing adalah {shadowSize}.",
    "weatherQuestion": "Cuaca apa yang saya butuhkan untuk {name}?",
    "weatherAnswer": "{name} muncul saat: {weather}.",
    "usedForQuestion": "Untuk apa {name} digunakan?",
    "usedForAnswer": "{name} memulihkan {energy} energi saat dimakan.",
  },
  "recipeFaq": {
    "ingredientsQuestion": "Bahan apa saja yang saya perlukan untuk {name}?",
    "ingredientsAnswer": "{name} membutuhkan: {ingredients}.",
    "cookingLevelQuestion": "Tingkat Cooking berapa yang saya perlukan untuk {name}?",
    "cookingLevelAnswer": "Anda memerlukan tingkat Cooking {level} untuk membuka {name}.",
    "sellPriceQuestion": "Berapa harga jual {name}?",
    "sellPriceAnswer": "{name} dijual seharga {price} emas.",
  },
  "itemDescription": {
    "foundAtClause": "bisa ditemukan di {locations}",
    "foundInHabitatClause": "berkaitan dengan habitat {habitat}",
    "requiresLevelClause": "membutuhkan minimal level {level} untuk didapatkan",
    "sellsForClause": "dijual seharga {price} gold",
    "restoresEnergyClause": "memulihkan {energy} energi saat dimakan",
    "joinWord": "dan",
  },
  "starTooltip": {
    "profitTitle": "Pengganda Bintang",
    "profitSubtitle": "Keuntungan per peringkat bintang",
    "profitFooterLabel": "1★ Untung",
    "sellPriceTitle": "Pengganda Bintang",
    "sellPriceSubtitle": "Harga jual per rating bintang",
    "sellPriceFooterLabel": "1★ Harga Jual",
  },
  "mastery": {
    "trackFishing": "Penguasaan Fishing",
    "trackBugCatching": "Penguasaan Bug Catching",
    "trackBirdwatching": "Penguasaan Birdwatching",
    "trackFarming": "Penguasaan Pertanian",
    "trackCooking": "Penguasaan Cooking",
    "unitCatches": "tangkapan",
    "unitCaptures": "pengamatan",
    "unitHarvests": "panen",
    "unitPreparations": "kali masak",
    "rankNovice": "Pemula",
    "rankExpert": "Pakar",
    "rankMaster": "Master",
    "trophyUnlocked": "Trofi",
    "footerHint": "Ketuk sebuah tingkat untuk menandai kemajuan Anda. Capai Master untuk membuka trofinya.",
    "unknownBody": "Kami belum tahu ambang penguasaan untuk item ini.",
    "unknownCta": "Anda tahu angkanya? Beri tahu kami",
    "suggestFieldLabel": "Ambang penguasaan Pemula",
    "suggestHint":
      "Cukup angka Pemula — pada semua item yang sudah kami konfirmasi, Pakar 3x dan Master 6x dari angka itu.",
  },
  "statSuggestion": {
    "unknownLabel": "Kami belum tahu",
    "suggestValueCta": "Sarankan nilai",
    "explainer":
      "Kami belum mengonfirmasi hal ini. Jika Anda mengetahuinya dari bermain, bagikan di bawah — setiap saran ditinjau sebelum dimasukkan ke situs, jadi tidak ada tekanan untuk yakin 100%.",
    "genericHint": "Cukup nomornya saja, tidak perlu format tambahan.",
    "energyHint": "Jumlah energi yang dipulihkan saat item ini dikonsumsi.",
    "sellPriceHint": "Harga jual dasar bintang 1, di Gold — kami akan menghitung bintang lainnya dari harga tersebut.",
    "habitatHint": "Dimana ditemukan — lokasi atau nama area.",
    "growthTimeHint": "Dalam hitungan menit (misalnya 90 untuk 1 jam 30 menit, 1440 untuk 1 hari).",
    "valueLabel": "Nilai",
    "customOption": "Lainnya (ketik sendiri)",
    "habitatTranslationFieldLabel": "Nama habitat dalam bahasa ini",
    "habitatTranslationHint": "Bagaimana lokasi/area ini disebut dalam bahasa ini.",
    "submitButton": "Kirim saran",
    "submitting": "Mengirim…",
    "successMessage": "Terima kasih! Kami akan segera meninjau saran Anda.",
    "errorMessage": "Tidak dapat mengirim saat ini — coba lagi nanti.",
  },
  "imageSuggestion": {
    "triggerLabel": "Sarankan gambar",
    "triggerLabelReplace": "Sarankan gambar yang berbeda",
    "fieldLabel": "Sarankan gambar",
    "explainer":
      "Kami belum memiliki gambar yang dikonfirmasi untuk ini. Unggah yang Anda punya — setiap saran ditinjau sebelum ditambahkan ke situs.",
    "explainerReplace":
      "Menurutmu gambar ini salah atau mungkin lebih baik? Unggah yang Anda punya — setiap saran ditinjau sebelum menggantikan gambar saat ini.",
    "pickFile": "Pilih foto (JPEG, PNG, atau WebP)",
    "hint": "Maks 5MB. Harap pastikan gambar tersebut benar-benar item ini.",
    "invalidType": "Hanya gambar JPEG, PNG, atau WebP yang diterima.",
    "tooLarge": "Ukuran gambar harus 5MB atau kurang.",
    "submitButton": "Kirim gambar",
    "submitting": "Mengunggah…",
    "successMessage": "Terima kasih! Kami akan segera meninjau gambar Anda.",
    "errorMessage": "Saat ini tidak dapat mengunggah — silakan coba lagi nanti.",
  },
  "generalFeedback": {
    "triggerLabel": "Ada masalah? Sarankan perbaikan",
    "fieldLabel": "Apa yang kurang tepat?",
    "hint": "Deskripsi salah, gambar salah, apa pun — beri tahu kami apa yang harus diperbaiki.",
  },
  "pageFeedback": {
    "triggerLabel": "Laporkan masalah pada halaman ini",
    "fieldLabel": "Apa masalahnya?",
    "hint": "Salah ketik, langkah rusak, info ketinggalan jaman — beri tahu kami.",
    "explainer":
      "Kami belum mengonfirmasi hal ini. Jika Anda melihat sesuatu yang aneh, bagikan di bawah — setiap kiriman ditinjau sebelum kami menindaklanjutinya, jadi tidak ada tekanan untuk yakin 100%.",
    "submitButton": "Kirim masukan",
    "submitting": "Mengirim…",
    "successMessage": "Terima kasih! Kami akan segera memeriksanya.",
    "errorMessage": "Tidak dapat mengirim saat ini — coba lagi nanti.",
  },
  "mapAreaUnknown": {
    "title": "Kami belum mengetahui daerah ini.",
    "description": "Bantu komunitas dengan menyumbangkan data lokasi untuk item ini.",
    "cta": "Bantu kami menambahkan ini",
    "fieldLabel": "Lokasi/daerah",
    "hint": "Jelaskan tempat Anda menemukannya — sertakan nama lokasi dan landmark terdekat.",
    "notPinnedTitle": "Tempat ini belum dipasangi pin pada peta.",
    "notPinnedDescription": "Kami mengetahui wilayah umumnya, namun belum memetakan penanda pastinya.",
  },
  "itemGuides": {
    "title": "Panduan Terkait",
  },
  "itemFallback": {
    "badge": "Terjemahan tertunda",
    "message": "Kami belum mengetahui nama item ini dalam bahasa ini.",
    "usingEnglish": "Menggunakan bahasa Inggris:",
    "helpMessage": "Kami belum mengetahui nama item ini. Ingin membantu kami?",
    "helpCta": "Bantu terjemahkan",
    "modalTitle": "Sarankan terjemahan",
    "fieldPlaceholder": "Nama item dalam bahasa ini",
    "submitButton": "Kirim saran",
    "submitting": "Mengirim…",
    "successMessage": "Terima kasih! Kami akan segera meninjau saran Anda.",
    "errorMessage": "Tidak dapat mengirim saat ini — coba lagi nanti.",
  },
  "notFoundPage": {
    "title": "404",
    "subtitle": "Ups, halaman ini tidak dapat ditemukan.",
    "description": "Anda mengembara ke area yang belum ada di Heartopia. Mari kita kembalikan ke jalur yang benar.",
    "primaryCta": "Kembali ke Rumah",
    "secondaryCta": "Lihat Peta Dunia",
  },
  "achievements": {
    "pill": "Pencapaian",
    "titlePrefix": "Buka kunci setiap",
    "titleAccent": "pencapaian",
    "subtitle": "Lacak kemajuan Anda dan temukan cara membuka setiap pencapaian di Heartopia.",
    "searchPlaceholder": "Cari pencapaian…",
    "filterAll": "Semua",
    "showHidden": "Tampilkan Tersembunyi",
    "hideHidden": "Sembunyikan yang Rahasia",
    "statTotal": "Total",
    "statCompleted": "Selesai",
    "statHidden": "Tersembunyi",
    "noResultsTitle": "Tidak ada pencapaian yang ditemukan",
    "noResultsBody": "Coba penelusuran atau filter lain.",
    "resetFilters": "Setel ulang filter",
    "lockedTitle": "???",
    "lockedBody": "Pencapaian ini masih menjadi misteri.",
    "titleGainedLabel": "Judul Diperoleh",
    "hintLabel": "Petunjuk",
    "notesLabel": "Catatan",
    "markDone": "Tandai sebagai selesai",
    "markNotDone": "Tandai sebagai belum selesai",
    "backToList": "Kembali ke Pencapaian",
    "relatedTitle": "Pencapaian Terkait",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "share": {
    "title": "Bagikan",
    "shareVia": "Bagikan melalui …",
    "copyLink": "Salin tautan",
    "linkCopied": "Disalin!",
  },
  "weather": {
    "pill": "Stasiun Cuaca",
    "titlePrefix": "Heartopia",
    "titleAccent": "Ramalan",
    "subtitle":
      "Periksa kondisi untuk merencanakan rute Anda, melihat peristiwa, dan bersiap menghadapi kemunculan langka.",
    "directoryTitle": "Panduan Cuaca & Event",
    "specialEvent": "Event Khusus",
    "openGuide": "Buka Panduan",
    "backToWeather": "Kembali ke Cuaca",
    "overviewTitle": "Ringkasan",
    "checklistTitle": "Jika Anda Hanya Punya 10 Menit",
    "activitiesTitle": "Kegiatan Utama",
    "bestForTitle": "Terbaik Untuk",
    "creaturesTitle": "Tersedia Selama Cuaca Ini",
    "creaturesMore": "lagi",
    "creaturesShowLess": "Tampilkan lebih sedikit",
    "noCreaturesData": "Kami belum memiliki makhluk yang ditandai untuk cuaca seperti ini.",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "events": {
    "pill": "Jadwal Heartopia",
    "titlePrefix": "Aktif",
    "titleAccent": "Event",
    "subtitle": "Dari festival musiman besar hingga minigame harian singkat, temukan semua yang terjadi di Heartopia.",
    "minigamesTitle": "Minigame Berulang",
    "seasonalTitle": "Event Musiman & Kolaborasi",
    "activeLabel": "Aktif",
    "endedLabel": "Berakhir",
    "viewEvent": "Lihat Event",
    "backToEvents": "Kembali ke Event",
    "requirementsTitle": "Persyaratan",
    "locationTitle": "Lokasi",
    "costTitle": "Biaya Masuk",
    "freeLabel": "Gratis",
    "dgLevelLabel": "Tingkat Developer's Guild",
    "questLabel": "Quest",
    "hobbyLabel": "Hobi",
    "quickFactsTitle": "Fakta Singkat",
    "unlockLabel": "Membuka kunci",
    "npcAreaLabel": "NPC / Daerah",
    "durationLabel": "Lamanya",
    "typeLabel": "Jenis",
    "howToStartTitle": "Bagaimana Memulainya",
    "howItWorksTitle": "Cara Kerjanya",
    "goalsRewardsTitle": "Tujuan & Imbalan",
    "tipsTitle": "Tip / Strategi",
    "datesTitle": "Tanggal Event",
    "overviewTitle": "Ringkasan",
    "highlightsTitle": "Highlight",
    "standoutRewardTitle": "Hadiah Menonjol",
    "faqTitle": "Pertanyaan yang Sering Diajukan",
  },
  "pets": {
    "hubBadge": "Panduan Hewan Peliharaan",
    "hubTitlePrefix": "Heartopia",
    "hubTitleAccent": "Hewan Peliharaan",
    "hubSubtitle": "Semua yang Anda butuhkan untuk membuka kunci, mengadopsi, dan merawat hewan peliharaan.",
    "hubUnlockTitle": "Buka Kunci Perawatan Hewan Peliharaan",
    "hubUnlockDesc": "Biasanya di Developer/Member Level 12 melalui Resident Requests.",
    "hubOrderTitle": "Kucing Pertama",
    "hubOrderDesc": "Anda harus mengadopsi kucing sebelum anjing membuka kuncinya.",
    "hubRotationTitle": "Rotasi Harian",
    "hubRotationDesc": "3 kucing + 3 anjing bergilir setiap hari di Pusat Adopsi.",
    "cardDogsTitle": "Anjing",
    "cardDogsSubtitle": "Ras • Peduli • Kelompok",
    "cardDogsDesc": "37 ras dengan kelompok ukuran dan catatan kepedulian.",
    "cardCatsTitle": "Kucing",
    "cardCatsSubtitle": "Ras • Sifat • Mantel",
    "cardCatsDesc": "18 ras dengan varian bulu dan warna.",
    "cardTraitsTitle": "Sifat-sifat",
    "cardTraitsSubtitle": "Semua sifat + pencarian",
    "cardTraitsDesc": "Daftar ciri-ciri dan pengaruhnya yang dapat dicari.",
    "cardGuideTitle": "Memandu",
    "cardGuideSubtitle": "Buka Kunci • Adopsi • Peduli",
    "cardGuideDesc": "Membuka alur plus lingkaran adopsi/perawatan harian.",
    "dogsBadge": "Panduan Anjing",
    "dogsTitlePrefix": "Heartopia",
    "dogsTitleAccent": "Anjing",
    "dogsSubtitle": "Buka kunci, adopsi, dan rawat anjing dengan katalog ras yang bersih.",
    "catsBadge": "Panduan Kucing",
    "catsTitlePrefix": "Heartopia",
    "catsTitleAccent": "Kucing",
    "catsSubtitle": "Ras, sifat, dan perawatan — bersih dan terpisah.",
    "quickInfoRotationTitle": "Rotasi Harian",
    "quickInfoRotationDesc": "3 kucing + 3 anjing bergilir setiap hari.",
    "quickInfoUnlockTitle": "Membuka kunci",
    "quickInfoUnlockDesc": "Dog Caring dibuka setelah Cat Caring.",
    "quickInfoOrderTitle": "Kucing Pertama",
    "quickInfoOrderDesc": "Kucing membuka kuncinya sebelum anjing.",
    "quickInfoTraitsTitle": "Sifat Acak",
    "quickInfoTraitsDescDogs": "Ciri-cirinya acak, tidak terikat pada ras.",
    "quickInfoTraitsDescCats": "Sifat bersifat acak dan berfokus pada perilaku.",
    "searchPlaceholder": "Cari ras…",
    "filterAll": "Semua",
    "filterSmall": "Kecil",
    "filterMedium": "Sedang",
    "filterLarge": "Besar",
    "noResults": "Tidak ada ras yang ditemukan",
    "traitsBadge": "Sifat Hewan Peliharaan",
    "traitsTitlePrefix": "Semua",
    "traitsTitleAccent": "Sifat-sifat",
    "traitsSubtitle": "Setiap sifat yang dimiliki hewan peliharaan dan apa artinya dalam perawatan sehari-hari.",
    "traitsSearchPlaceholder": "Ciri-ciri pencarian…",
    "effectLabel": "Memengaruhi",
    "guideBadge": "Perawatan Hewan Peliharaan",
    "guideTitlePrefix": "Adopsi",
    "guideTitleAccent": "Memandu",
    "guideSubtitle": "Buka kunci kepedulian hewan peliharaan, adopsi kucing pertama Anda, lalu kembangkan ke anjing.",
    "guideStepsTitle": "Cara Membuka Kunci",
    "guideAdoptionTitle": "Bagaimana Adopsi Bekerja",
    "guideCareTitle": "Lingkaran Perawatan Harian",
    "backToPets": "Kembali ke Hewan Peliharaan",
    "viewBreed": "Lihat Ras",
    "groupLabel": "Ukuran",
    "dogLabel": "Anjing",
    "catLabel": "Kucing",
    "variantsLabel": "Varian Mantel yang Dikenal",
    "suggestTitle": "Hilangnya ras atau detailnya?",
    "suggestDogsBody": "Bantu kami memperluas katalog anjing dengan ras, varian, atau koreksi.",
    "suggestCatsBody": "Bantu kami memperluas katalog kucing dengan ras, varian bulu, atau koreksi.",
    "suggestButton": "Sarankan entri",
    "suggestFieldLabel": "Informasi hewan peliharaan",
    "suggestHint": "Bagikan ras, varian, sumber, atau koreksi lho.",
    "viewAllTraits": "Lihat semua sifat",
  },
  "dailyChecklist": {
    "badge": "Pelacak Harian",
    "titlePrefix": "Sehari-hari",
    "titleAccent": "Heartopia",
    "subtitle": "Lacak tugas harian, sumber daya, dan rotasi toko Anda. Semuanya diatur ulang dengan hari yang baru.",
    "progressTitle": "Kemajuan Harian",
    "progressComplete": "menyelesaikan",
    "allDone": "Selamat! Anda telah menyelesaikan semua tugas hari ini!",
    "quickTasksTitle": "Tugas Cepat",
    "quickTasksDesc": "Tindakan harian penting yang disetel ulang setiap hari.",
    "shopsTitle": "Rotasi Toko",
    "shopsDesc": "Periksa stok berputar dari vendor ini.",
    "resetInfo": "Reset secara otomatis berdasarkan tanggal lokal Anda.",
    "customTitle": "Tugas Khusus",
    "addCustom": "Menambahkan",
    "customPlaceholder": "Nama tugas…",
    "customEmpty": "Belum ada tugas khusus.",
    "remove": "Hapus",
  },
  "codes": {
    "badge": "Pusat Penebusan",
    "title": "HADIAH",
    "titleAccent": "KODE",
    "subtitle": "Tukarkan kode ini dalam game untuk menerima hadiah spesial, emas, dan item eksklusif!",
    "statActive": "Aktif",
    "statExpired": "Kedaluwarsa",
    "statTotal": "Total",
    "howToTitle": "Cara Menebus",
    "howToStep1": "Buka menu permainan",
    "howToStep2": "Ketuk 'Pengaturan' > 'Tukarkan Kode'",
    "howToStep3": "Masukkan kode persis seperti yang ditunjukkan",
    "howToStep4": "Konfirmasikan dan terima hadiah Anda!",
    "rewardsLabel": "Hadiah",
    "noRewardsLabel": "Tidak ada hadiah yang terdaftar",
    "starQualityHint": "Kode ini memberikan item dengan kualitas bintang tertentu.",
    "unconfirmedRewardHint":
      "Kami belum memiliki item ini di katalog kami, jadi ini adalah ID mentah dalam game, bukan nama yang dikonfirmasi.",
    "expiredText": "Kode ini telah kedaluwarsa dan tidak dapat ditukarkan lagi.",
    "copyCode": "Salin kode",
    "copied": "Disalin!",
    "statusActive": "AKTIF",
    "statusExpired": "KEDALUWARSA",
    "redeemedLabel": "Ditebus",
    "markRedeemed": "Tandai sebagai telah ditebus",
    "unmarkRedeemed": "Hapus tanda telah ditebus",
    "goldLabel": "Gold",
    "starLabel": "Wishing Star",
    "heartLabel": "Moonlight Crystal",
    "maintenanceNote":
      "Kode diperiksa secara berkala tetapi dapat kedaluwarsa tanpa pemberitahuan — jika tidak berfungsi dalam game, kemungkinan kode sudah usang.",
  },
  "winterTracker": {
    "badge": "Jurnal Fashionwave",
    "titlePrefix": "Winter Frost",
    "titleAccent": "Pelacak Barang",
    "subtitle":
      "Lacak setiap item edisi terbatas dari Winter Frost musim — acara ini telah berakhir, tetapi Anda masih dapat menelusuri apa yang tersedia.",
    "endedNote":
      "Event ini telah berakhir — item yang ditampilkan di sini tidak lagi bisa diperoleh dalam game. Informasinya disimpan sebagai referensi.",
    "searchPlaceholder": "Cari item…",
    "filterAll": "Semua",
    "filterAccessory": "Aksesoris",
    "filterBag": "Tas",
    "filterClothing": "Pakaian",
    "filterFurniture": "Mebel",
    "filterEmote": "emosi",
    "filterVehicle": "Kendaraan",
    "filterTool": "Peralatan",
    "filterPet": "Barang Hewan Peliharaan",
    "filterPuzzle": "Teka-teki",
    "collected": "Dikumpulkan",
    "missing": "Belum Dikumpulkan",
    "noResults": "Tidak ada item yang ditemukan",
    "costLabel": "Fashionwave Tokens",
    "backToEvent": "Kembali ke Winter Frost",
  },
  "support": {
    "badge": "Dukung heartopia.guide",
    "titlePrefix": "Pertahankan",
    "titleAccent": "Jantung",
    "titleSuffix": "Pukulan",
    "subtitle":
      "heartopia.guide adalah proyek yang dibuat dengan penuh semangat untuk komunitas. Dukunganmu membantu menjaga server tetap berjalan dan konten terus diperbarui!",
    "donateCta": "Dukung Proyek",
    "donateDescription": "Setiap kontribusi membantu mencakup hosting, domain, dan waktu pengembangan.",
    "creatorLabel": "Lucas Diniz",
    "creatorRole": "Pencipta heartopia.guide",
    "creatorBadge": "Pengembang & Desainer",
    "footerNote": "Terima kasih telah menjadi bagian dari perjalanan ini!",
  },
  "about": {
    "badge": "Proyek Penggemar · Tidak Resmi",
    "title": "Tentang Heartopia Guide",
    "subtitle":
      "Heartopia Guide adalah situs buatan komunitas yang membantu pemain menemukan informasi game — panduan, pelacak, checklist, item, dan referensi event — dengan cepat dan teratur.",
    "lastUpdatedLabel": "Terakhir diperbarui",
    "pillEventTrackers": "Pelacak Event",
    "pillGuides": "Panduan",
    "pillChecklists": "Daftar periksa",
    "pillAlwaysUpdated": "Selalu Diperbarui",
    "whatYouFindTitle": "Apa yang akan Anda temukan di sini",
    "whatYouFind1": "Pelacak acara dan daftar item (bila tersedia)",
    "whatYouFind2": "Panduan dan halaman referensi untuk mekanik game",
    "whatYouFind3": "Halaman utilitas untuk mempermudah rutinitas harian/mingguan",
    "whatYouFind4": "Situs yang berkembang seiring waktu — diperbarui seiring tersedianya informasi baru",
    "transparencyTitle": "Transparansi dan pemberitahuan proyek penggemar",
    "transparencyP1":
      "Ini adalah proyek penggemar independen dan tidak resmi. Kami tidak berafiliasi dengan, disponsori oleh, atau didukung oleh pencipta atau penerbit Heartopia.",
    "transparencyP2": "Semua merek dagang, nama, dan aset adalah milik pemiliknya masing-masing.",
    "creatorTitle": "Siapa di balik ini",
    "creatorIntro": "heartopia.guide bukan proyek anonim — situs ini dibuat dan dikelola oleh orang sungguhan.",
    "creatorName": "Lucas Diniz",
    "creatorRole": "Pencipta & pengembang heartopia.guide",
    "creatorLinkLabel": "lucashdo.com",
    "sourcesTitle": "Dari mana informasi berasal",
    "sourcesIntro": "Informasi dapat bersumber dari:",
    "sourcesItem1": "Observasi dan pengujian dalam game",
    "sourcesItem2": "Kontribusi komunitas",
    "sourcesItem3": "Pembaruan game resmi",
    "sourcesNote":
      "Bahkan dengan hati-hati, beberapa data mungkin tidak lengkap atau kedaluwarsa — terutama selama acara aktif.",
    "adsTitle": "Iklan dan keberlanjutan",
    "adsP1":
      "Untuk menjaga situs tetap berjalan dan menutupi biaya (domain, hosting, peralatan), kami mungkin menampilkan iklan.",
    "adsP2":
      "Layanan periklanan seperti Google mungkin menggunakan cookie atau teknologi serupa untuk menayangkan dan mengukur iklan.",
    "copyrightTitle": "Hak cipta",
    "copyrightText":
      "Jika Anda adalah pemegang hak dan yakin bahwa konten harus dihapus atau disesuaikan, hubungi kami dengan menyertakan URL dan detail yang relevan. Kami akan meninjau dan bertindak secepat mungkin.",
    "contactTitle": "Kontak",
    "contactEmailLabel": "E-mail",
    "footerNote": "Dibuat dengan cinta oleh komunitas Heartopia",
  },
  "legal": {
    "lastUpdatedLabel": "Terakhir diperbarui",
    "lastUpdatedValue": "2026-02-13",
    "contactHeading": "Kontak",
    "contactLinkLabel": "Tentang & halaman Kontak",
    "privacyTitle": "Kebijakan Privasi",
    "privacyIntro":
      "Kebijakan Privasi ini menjelaskan bagaimana heartopia.guide mengumpulkan, menggunakan, dan melindungi informasi pribadi saat Anda mengakses situs ini.",
    "privacyDataHeading": "Data yang mungkin kami kumpulkan",
    "privacyData":
      "Bergantung pada cara Anda menggunakan situs, kami dapat mengumpulkan: data penelusuran/penggunaan (halaman yang dilihat, klik, tanggal/waktu, perujuk, jenis perangkat/browser, bahasa); pengidentifikasi teknis (misalnya IP dalam log, data keamanan dan kinerja); cookie dan teknologi serupa (lihat Kebijakan Cookie); dan data yang Anda berikan (misalnya jika Anda mengirim email kepada kami atau mengirimkan masukan). Kami tidak meminta data sensitif (misalnya kesehatan, agama, biometrik).",
    "privacyHowWeUseHeading": "Bagaimana kami menggunakan data",
    "privacyHowWeUse":
      "Kami menggunakan data untuk menyediakan dan memelihara situs web, meningkatkan konten dan kinerja, mencegah penyalahgunaan dan penipuan, menanggapi pesan dan dukungan, mengukur pemirsa saat diaktifkan, dan menayangkan iklan (jika ada) serta mengukur kinerja.",
    "privacySharingHeading": "Pembagian data",
    "privacySharing":
      "Kami dapat berbagi data dengan penyedia layanan (hosting, analitik, CDN, dan/atau periklanan) untuk mengoperasikan situs; bila diwajibkan secara hukum (perintah pengadilan, kewajiban peraturan); dan untuk melindungi situs dan pengguna. Kami tidak menjual informasi pribadi.",
    "privacyRetentionHeading": "Penyimpanan",
    "privacyRetention":
      "Kami menyimpan data hanya selama diperlukan untuk tujuan yang dijelaskan (atau sebagaimana diwajibkan oleh hukum). Log teknis dapat disimpan untuk jangka waktu terbatas untuk keamanan dan diagnostik.",
    "privacyRightsHeading": "Hak Anda",
    "privacyRights":
      "Anda dapat meminta hak yang berlaku berdasarkan undang-undang yang relevan (misalnya akses, koreksi, penghapusan, portabilitas bila berlaku, informasi tentang berbagi, penarikan persetujuan). Untuk menggunakan hak, hubungi kami melalui halaman kontak dengan rincian permintaan Anda.",
    "privacyAdvertisingHeading": "Periklanan",
    "privacyAdvertising":
      "Kami menggunakan layanan periklanan pihak ketiga, termasuk Google AdSense. Penyedia ini dapat menggunakan cookie dan pengidentifikasi serupa untuk menayangkan iklan, termasuk iklan hasil personalisasi berdasarkan kunjungan Anda sebelumnya ke situs ini dan situs web lainnya. \n\nAnda dapat memilih untuk tidak menerima iklan hasil personalisasi melalui Google Ads Settings dan/atau AboutAds (penyisihan iklan berbasis minat). Iklan yang tidak dipersonalisasi mungkin masih ditampilkan berdasarkan konten umum dan lokasi.",
    "privacyContactBefore": "Untuk bertanya atau menggunakan hak Anda, buka ",
    "termsTitle": "Ketentuan Penggunaan",
    "termsIntro":
      "Dengan mengakses situs ini (“Situs”), Anda menyetujui Ketentuan ini. Situs ini menyediakan konten informasi dan alat komunitas. Anda setuju untuk menggunakannya secara sah dan hormat.",
    "termsUseHeading": "Kekayaan intelektual dan merek dagang",
    "termsUse":
      "Konten Situs Asli (teks, struktur, desain) adalah milik heartopia.guide kecuali dinyatakan lain. Heartopia, nama karakter/item, merek dagang, dan aset yang direferensikan adalah milik pemiliknya masing-masing. Konten pihak ketiga mungkin muncul untuk referensi; jika Anda adalah pemegang hak dan ingin penghapusan atau penyesuaian, hubungi kami.",
    "termsLiabilityHeading": "Penafian dan batasan tanggung jawab",
    "termsLiability":
      'Situs ini disediakan "sebagaimana adanya." Konten mungkin tidak lengkap, ketinggalan jaman, atau untuk sementara tidak tersedia. Kami tidak menjamin ketersediaan berkelanjutan atau keakuratan penuh. Sejauh diizinkan oleh hukum, kami tidak bertanggung jawab atas kerusakan tidak langsung, kehilangan data, hilangnya keuntungan, atau kerugian lain yang timbul dari penggunaan Situs. Kami dapat memperbarui Situs dan Ketentuan ini kapan saja; penggunaan terus menerus setelah perubahan berarti penerimaan.',
    "termsContactBefore": "Untuk pertanyaan atau permintaan, buka ",
    "cookiesTitle": "Kebijakan Cookie",
    "cookiesIntro":
      "Kebijakan Cookie ini menjelaskan bagaimana heartopia.guide menggunakan cookie dan teknologi serupa untuk mengenali pengunjung dan meningkatkan pengalaman.",
    "cookiesWhatAreHeading": "Apa itu cookie",
    "cookiesWhatAre":
      "Cookies adalah file teks kecil yang disimpan di browser Anda saat Anda mengunjungi suatu situs web. Mereka membantu dengan fungsionalitas, preferensi, dan statistik penggunaan.",
    "cookiesHowWeUseHeading": "Bagaimana kami menggunakan cookie",
    "cookiesHowWeUse":
      "Kami dapat menggunakan cookie untuk: Penting (wajib) — diperlukan untuk fungsionalitas situs inti (keamanan, kinerja, preferensi penting). Preferensi — mis. bahasa, tema, filter. Analisis — untuk memahami bagaimana situs digunakan dan meningkatkan konten. Periklanan (jika berlaku) Mitra — dapat menggunakan cookie untuk mengukur kinerja dan mempersonalisasi iklan.",
    "cookiesThirdPartyHeading": "Cookie pihak ketiga",
    "cookiesThirdParty":
      "Kami dapat menggunakan layanan pihak ketiga (misalnya hosting, analitik, CDN, jaringan iklan). Penyedia ini dapat mengatur cookie mereka sendiri. Anda dapat meninjau atau mengelolanya melalui spanduk izin situs.",
    "cookiesConsentHeading": "Persetujuan dan kontrol",
    "cookiesConsent":
      "Anda dapat mengontrol cookie melalui spanduk persetujuan yang ditampilkan pada kunjungan pertama Anda, pengaturan browser (memblokir atau menghapus cookie), atau mode pribadi/penyamaran. Memblokir cookie penting dapat merusak fitur situs.",
    "cookiesContactBefore": "Untuk pertanyaan tentang cookie, buka ",
    "sitemapTitle": "Peta Situs",
    "sitemapIntro": "Bagian utama dan halaman heartopia.guide.",
    "sitemapXmlLabel": "sitemap.xml",
    "sitemapXmlNote": "untuk mesin pencari",
    "sitemapResourcesHeading": "Sumber Daya",
    "sitemapSupportHeading": "Dukungan",
    "sitemapLegalHeading": "Legal",
  },
  "consent": {
    "bannerLabel": "Persetujuan cookie",
    "message":
      "Kami menggunakan cookie untuk fitur-fitur penting situs dan, jika Anda mengizinkannya, untuk mengukur penggunaan dan menampilkan iklan.",
    "learnMore": "Pelajari lebih lanjut tentang cookie",
    "acceptCta": "Terima semuanya",
    "rejectCta": "Tolak yang tidak penting",
  },
};

export default id;
